/**
 *
 * TextMessage
 *
 */

import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import textToUrl from 'utils/textToUrl.js';
import {eventTypes} from "../../../utils/eventTypes";

const MessageWrapper = styled.div`
  display: block;
  font-size: 14px;
`;

const ClientMessage = styled(({ headerBackgroundColor, headerTextColor, children, ...others }) => (
  <div {...others}>{children}</div>
))`
  margin-left: auto;
  overflow-wrap: break-word;
  float: right;
  line-height: 20px;
  background-color: ${p => p.headerBackgroundColor || p.theme.palette.blue3};
  color: ${p => p.headerTextColor || 'white'};
  border-radius: 15px 15px 5px 15px;
  padding: 10px 20px;
  text-align: left;
  max-width: 250px;
  white-space: pre-wrap;
  a {
    color: ${p => p.headerTextColor || 'white'};
  }
`;

const ServerMessage = styled.div`
  overflow-wrap: break-word;
  color: #3d4e63cc;
  width: 100%;
  text-align: left;
  line-height: 20px;
  border-radius: 15px 15px 15px 5px;
  padding: 10px 20px;
  background-color: ${p => p.theme.palette.blue5};
  box-sizing: border-box;
  display: inline-block;
  white-space: pre-wrap;
  ol, ul {
    display: table;
    margin-bottom: 2px;
    margin-top: 2px;
    padding-left: 25px;
  }
  word-break: break-word;
  p {
    margin: 0;
  }
  a {
    color: black;
  }
`;

const SendingMessage = styled.div`
  font-size: 10px;
  color: ${p => p.theme.palette.grey2};
`;

const Translate = (text, category, keyValues, Language) => {
  if(!Language || !category) return text;
  if(category === "articleSearchSuccess"){
    return text.replace("We found some articles that may be helpful for you.", Language.backend[category])
  }
  let resultantText = Language.backend[category];
  if(keyValues && Array.isArray(keyValues)){
    for(let i=0; i<keyValues.length; i++) resultantText = resultantText.replace(/\{[a-zA-Z]*?\}/,keyValues[i]);
  }
  return resultantText;
}

export const TextMessage = ({ userSettingColor, sender, Language, text, category, keyValues, mentions, sending, userConfig, currentChannel, actualMessage}) => {
  text = Translate(text, category, keyValues, Language);
  let message = text;
  if (text && mentions) {
    for (let mention of mentions) {
      if (text.substr(mention.start, mention.end + 1) === `<user:${mention.id}>`) {
        message = text.substr(0, mention.start) + '@' + mention.name + text.substr(mention.end + 1);
      }
    }
  }

  return (
    <MessageWrapper id="insent-text-message-message-wrapper" sender={sender} sending={sending}>
      {sender && sender === 'client' ? (
        <ClientMessage
          id="insent-text-message-message-wrapper-client-message"
          headerBackgroundColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
          headerTextColor={userSettingColor ? userSettingColor.headerTextColor : null}
        >
          {sending && <SendingMessage>{Language && Language.TextMessageSending}</SendingMessage>}
          {ReactHtmlParser(message.trim())}
        </ClientMessage>
      ) : (
        <ServerMessage>{ReactHtmlParser(message)}</ServerMessage>
      )}
    </MessageWrapper>
  );
};

TextMessage.propTypes = {
  userSettingColor: PropTypes.object,
  sender: PropTypes.string,
  text: PropTypes.string,
};

export default TextMessage;
